import service from "@/store/services/inverter-service";

const state = {
  list: {},
  inverter: false,
};

const mutations = {
  SET_INVERTERS: (state, list) => {
    state.list = list;
  },
  SET_INVERTER: (state, inverter) => {
    state.inverter = inverter;
  },
};

const actions = {
  create({ rootGetters }, inverter) {
    return service
      .create(inverter, rootGetters["inverter/inverter"])
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  read({ commit, rootGetters }, params) {
    // let id = rootGetters["product_category/list"].find(
    //   (category) => category.name === "inverter"
    // ).id;
    let id = 1;
    return service
      .read(params, id)
      .then(({ inverters }) => {
        commit("SET_INVERTERS", inverters);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  update({ _ }, params) {
    return service
      .update(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  destroy({ _ }, inverter) {
    return service
      .destroy(inverter)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  },
  getConfigsById({ _ }, id) {
    return service
      .getConfigsById(id)
      .then(({ inverter_configs }) => {
        return Promise.resolve(inverter_configs);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getAttachmentsById({ _ }, id) {
    return service
      .getAttachmentsById(id)
      .then(({ inverter_attachments }) => {
        return Promise.resolve(inverter_attachments);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  setCreatedProduct({ commit }, params) {
    commit("SET_INVERTER", params);
  },
};

const getters = {
  list: (state) => state.list,
  inverter: (state) => state.inverter,
};

const inverter = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inverter;
